import { useQuery, UseQueryResult } from '@tanstack/react-query';
import deploymentService from '../services/DeploymentService';
import { ActiveDeploymentResponse } from '../models/Deployment';

export const ACTIVE_DEPLOYMENT_QUERY_KEY = ['deployment', 'active'] as const;

/**
 * 현재 구동 중(활성) 현장 조회 훅.
 *
 * 반환 데이터는 `data.data` — null이면 현재 구동 중인 현장 없음.
 * staleTime 10s: 짧은 시간 내 중복 호출 방지.
 * 폴링은 이 훅이 아니라 useDeploymentPolling 에서 수행 (진행 중일 때만).
 */
export function useActiveDeployment(): UseQueryResult<ActiveDeploymentResponse, Error> {
  return useQuery<ActiveDeploymentResponse, Error>({
    queryKey: ACTIVE_DEPLOYMENT_QUERY_KEY,
    queryFn: () => deploymentService.getActiveDeployment(),
    staleTime: 10_000,
    retry: 1,
  });
}
